import SharedLayouts from "../Layouts/SharedLayout";
import * as rsuite from 'rsuite';
import {
  useReactTable,
  getCoreRowModel,
} from "@tanstack/react-table";
import useToaster from 'rsuite/useToaster';
import React, { useEffect, useState, useRef } from "react";
import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import * as General from '../General/General';
import "moment/locale/fa"; // for Persian localization;
import { useNavigate } from "react-router-dom";
import CrudPageHeader from "../components/CrudPageHeader";
import DataTable from "../components/DataTable";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";
import CrudFormModal from "../components/CrudFormModal";

const Foto = () => {
    //#region const
    const navigate = useNavigate();
    const [ShowModal, setShowModal] = useState(false);
    const [Fotos, setFotos] = useState([]);
    const [ShowDeleteModal, setShowDeleteModal] = useState(false);
    const [Image, setImage] = useState("");
    const [ImageName, setImageName] = useState("");
    const [Title, setTitle] = useState("");
    const [Content, setContent] = useState("");
    const inputFile = useRef(null);
    const [PrevImageName, setPrevImageName] = useState("");
    const [FotoId, setFotoId] = useState(General.GuidEmpty());
    const [Order,setOrder] = useState(0);
    const [ErrorMsg, setErrorMsg] = useState("");
    const toaster = useToaster();
    //#endregion

    //#region method
    const clearDependecies = () => {
        setFotoId(General.GuidEmpty());
        setTitle("");
        setContent("");
        setImage("");
        setImageName("");
        setPrevImageName("");
        handleReset();
    }
    const CheckValidation = () => {
        if (Title == "") {
            setErrorMsg('لطفا عنوان را وارد کنید');
            toaster.push(General.ShowMessage('error', 'لطفا عنوان را وارد کنید'), 'topCenter');
            return false;
        }
        else if (FotoId === General.GuidEmpty() && !Image) {
            setErrorMsg('لطفا عکس را وارد کنید');
            toaster.push(General.ShowMessage('error', 'لطفا عکس را وارد کنید'), 'topCenter');
            return false;
        }
        else {
            return true;
        }
    }
    const Delete = () => {
        var RequestOption = {
            url: General.ApiRoot() + '/foto/delete/' + FotoId,
            method: "delete",
            headers: General.AuthHeader(),
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    setErrorMsg("");
                    toaster.push(General.ShowMessage('success', 'عملیات حذف با موفقیت انجام شد'), 'topCenter');
                    GetFotos();
                    setFotoId(General.GuidEmpty());
                    setShowDeleteModal(false);
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در انجام عملیات';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }
    const Save = () => {
        if (CheckValidation()) {
            setErrorMsg("");
            const isNew = FotoId === General.GuidEmpty();
            const formData = new FormData();
            formData.append('FormFile', Image); // Ensure Image is correctly set
            formData.append('FileName', ImageName);
            formData.append('Title', Title);
            formData.append('Content', Content);
            formData.append('Id', FotoId);
            formData.append('PrevFileName', PrevImageName);
            formData.append('Order', Order);
            const requestOptions = {
                url: General.ApiRoot() + '/foto/' + (isNew ? 'insert' : 'update'),
                method: "post",
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    ...General.AuthHeader(),
                },
            };

            trackPromise(
                axios(requestOptions)
                    .then(function (result) {
                        toaster.push(General.ShowMessage('success', 'عملیات با موفق انجام شد'), 'topCenter');
                        GetFotos();
                        clearDependecies();
                        if (!isNew) {
                            setShowModal(false);
                        }
                    }).catch((error) => {
                        const msg = error?.response?.data?.message || 'عملیات با خطا مواجه شد';
                        setErrorMsg(msg);
                        toaster.push(General.ShowMessage('error', msg), 'topCenter');
                    })
            );
        }
    }
    const handleReset = () => {
        if (inputFile.current) {
            inputFile.current.value = "";
            inputFile.current.type = "text";
            inputFile.current.type = "file";
        }
    };
    const GetFotoById = (Id) => {
        setFotoId(Id);
        var RequestOption = {
            url: General.ApiRoot() + '/foto/getById/' + Id,
            method: "get",
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    const row = result.data && result.data[0];
                    if (row) {
                        setTitle(row.Title);
                        setContent(row.Content);
                        setPrevImageName(row.FileName);
                        setOrder(row.Order);
                        setShowModal(true);
                    }
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در برقراری ارتباط با سرور';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }
    const AddFoto = () => {
        setShowModal(true);
    }
    const GetFotos = () => {
        var RequestOption = {
            url: General.ApiRoot() + '/foto/getAll',
            method: "get",
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    setFotos(result.data)
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در برقراری ارتباط با سرور';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }
    //#endregion

    //#region handler
    const ImageCheck = (e) => {
        setImage(e.target.files[0]); // Set the file to Image state
        setImageName(e.target.files[0].name);
    }
    //#endregion

    const columns = [
        {
            id: "title",
            header: () => <div className="text-right">عنوان گالری تصاویر</div>,
            cell: ({ row }) => <div className="">{row.original.Title}</div>,
        },
        {
            id: "header",
            header: () => <div className="text-right">هدر</div>,
            cell: ({ row }) => <div className="">{row.original.Header}</div>,
        },
        {
            id: "order",
            header: () => <div className="text-right">ترتیب نمایش</div>,
            cell: ({ row }) => <div className="">{row.original.Order}</div>,
        },
        {
            id: "image",
            header: () => <div className="text-right">عکس</div>,
            cell: ({ row }) => <div className="">
                <img
                    className="w-2/4"
                    src={row.original.ImageURL}
                    alt={row.original.Title || "تصویر"}
                />
            </div>,
        },
        General.actionsColumn(GetFotoById, (id) => (setFotoId(id), setShowDeleteModal(true))),
    ];

    const table = useReactTable({
        data: Fotos,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    useEffect(() => {
        // Check if the user is authenticated
        if (!General.isLoggedIn()) {
          navigate('/'); // Redirect to login if not authenticated
        }
        else{
            GetFotos();
        }
      }, []);
    return (
        <SharedLayouts>
            <div className="bg-white h-screen w-full px-2">
                {ErrorMsg && (
                    <rsuite.Message type="error" showIcon closable onClose={() => setErrorMsg("")} className="mb-2">
                        {ErrorMsg}
                    </rsuite.Message>
                )}
                <CrudPageHeader title="گالری تصاویر" onAdd={AddFoto} />
                <DataTable table={table} />
            </div>
            <CrudFormModal
                open={ShowModal}
                title="تعریف عکس جدید"
                onClose={() => (setShowModal(false), clearDependecies())}
                onSave={Save}
            >
                <rsuite.Grid fluid>
                    <rsuite.Row>
                        <rsuite.Col className="mt-3" xs={12}>
                            <label>عنوان</label>
                            <rsuite.Input className="mt-1" value={Title} onChange={(e) => setTitle(e)} />
                        </rsuite.Col>
                        <rsuite.Col className="mt-3" xs={12}>
                            <label>ترتیب نمایش</label>
                            <rsuite.InputNumber className="mt-1" value={Order} onChange={(e) => setOrder(e)} />
                        </rsuite.Col>
                        <rsuite.Col className="mt-3" xs={24}>
                            <label>توضیحات</label>
                            <rsuite.Input className="mt-1" value={Content} onChange={(e) => setContent(e)} />
                        </rsuite.Col>
                        <rsuite.Col className="mt-3" xs={19}>
                            <label>انتخاب عکس</label>
                            <rsuite.Input
                                type="file"
                                onInput={ImageCheck}
                                ref={inputFile}
                                className="mt-1 mb-3" />
                        </rsuite.Col>
                        <rsuite.Col xs={4} className="mt-9">
                            <rsuite.Button onClick={handleReset}>حذف عکس</rsuite.Button>
                        </rsuite.Col>
                    </rsuite.Row>
                </rsuite.Grid>
            </CrudFormModal>

            <ConfirmDeleteModal
                open={ShowDeleteModal}
                message="آیا از حذف این عکس مطمئن هستید؟در صورت حذف قادر به بازیابی اطلاعات نخواهید بود."
                onConfirm={Delete}
                onCancel={() => (setShowDeleteModal(false), setFotoId(General.GuidEmpty()))}
            />
        </SharedLayouts>
    )
}

export default Foto
